import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NavbarV3 extends Component {

	render() {
		let publicUrl = process.env.PUBLIC_URL + '/'
		let imgattr = 'logo'
		let anchor = '#'
		return (
			<div className="navbar-area navbar-area-2">
				{/* topbar end*/}
				
				{/* topbar end*/}
				{/* navbar start */}
				<nav className="navbar navbar-expand-lg">
					<div className="container nav-container">
						<div className="responsive-mobile-menu">
							<div className="logo d-block mr-5">
								<Link  className="main-logo" to="/"><img style={{width:"100px"}} src={publicUrl + "assets/img/21601.png"} alt="img" /></Link>
							</div>
							<button className="menu toggle-btn d-block d-lg-none" data-target="#miralax_main_menu" aria-expanded="false" aria-label="Toggle navigation">
							</button>
						</div>


					</div>
				</nav>
			</div>

		)
	}
}


export default NavbarV3